import { useEffect } from "react";
import { firstValueFrom } from "rxjs";
import { trackingService } from "services/trackingService";
import { AuditEventType } from "types/track/AuditEventType";

export function useTrackPageEffect({    
    eventType,
    otherProperties = {},
}: {
    eventType: AuditEventType;
    otherProperties?: Record<string, any>;
}){
    useEffect(() => {
        firstValueFrom(trackingService.trackCustomEvent$({
            eventType,
            otherProperties,
        }));
    }, []);
}
